export * from './publishers-file.configuration';
